import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertInfo } from '../../../../../models/alert-info';
import { SavedDataInfo } from '../../../../../models/form/saved-data-info';
import { AlertNotificationService } from '../../../../../services/alert-notification.service';
import { ItemProductsService } from '../../../../../services/api/general-settings/item-products.service';
import { FormService } from '../../../../../services/form.service';
import { ValidatorService } from '../../../../../services/validator.service';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { InputFieldComponent } from '../../../../../components/form/input-field/input-field.component';
import { Location } from '@angular/common';

@Component({
  selector: 'item-products-form',
  imports: [NgbAlert, InputFieldComponent, ReactiveFormsModule],
  templateUrl: './item-products-form.component.html',
  styleUrl: './item-products-form.component.scss'
})
export class ItemProductsFormComponent {
  @Input() itemProduct?: any;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;

  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  constructor(
    private validatorService: ValidatorService,
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private itemProductsService: ItemProductsService,
    private location: Location,
  ) { }


  ngOnInit(): void {
    this.form = new FormGroup({
      code: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['itemProduct'] && changes['itemProduct'].currentValue) {
      this.form.patchValue({
        code: this.itemProduct.code,
        name: this.itemProduct.name,
      });
    }
  }

  /**
   * *******************
   * Submit form methods
   * *******************
   */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {

    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    if (this.form.valid) {

      const values = Object.assign(
        this.form.value,
        {
          tenantId: 1,
        },
      )

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      const serviceMethod = this.itemProduct ? this.itemProductsService.update(this.itemProduct.itemProductId, values) : this.itemProductsService.create(values);
      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response)
        },
        error: (error: any) => {
          this.submitFormError(error)
        }
      })
    }
  }

  goBack(): void {
    this.location.back();

  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */



  getItemProductCodeInput(): FormControl { return this.getFormControl('code'); }
  getItemProductNameInput(): FormControl { return this.getFormControl('name'); }
  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }
}
